import { CtSourceOrder } from '@/models/interfaces/content-type'
import { ContentType } from '@/services/directr'
import ContentModule from '@/utils/store'

export const model = {
    id: {
      field: 'id',
      label: 'ID',
      validator: () => true,
      type: 'string',
      required: true
    },
    reference: {
      field: 'reference',
      label: 'Reference',
      validator: () => true,
      type: 'string',
      required: true
    },
    service: {
      field: 'service',
      label: 'Service',
      validator: () => true,
      type: 'string',
      required: false
    },
    status: {
      field: 'status',
      label: 'Status',
      validator: () => true,
      type: 'array',
      required: true
    },
    status_info: {
      field: 'status_info',
      label: 'Status Information',
      validator: () => true,
      type: 'json',
      required: true
    },
    catalogue: {
      field: 'catalogue',
      label: 'Catalogue',
      validator: () => true,
      type: 'string',
      required: true
    },
    type: {
      field: 'type',
      label: 'type',
      validator: () => true,
      type: 'string',
      default: 'default',
      required: false
    },
    'shipping-address': {
      field: 'shipping_address',
      label: 'Address',
      validator: () => true,
      type: 'json',
      required: false
    },
    products: {
      field: 'products',
      label: 'Products',
      validator: () => true,
      type: 'json',
      required: true
    },
    shipments: {
      field: 'shipments',
      label: 'Shipments',
      validator: () => true,
      type: 'json',
      required: false
    },
    fulfillments: {
      field: 'fulfillments',
      label: 'Fulfillments',
      validator: () => true,
      type: 'json',
      required: false
    },
    notes: {
      field: 'notes',
      label: 'Customer Notes',
      validator: () => true,
      readonly: true,
      type: 'string',
      required: false
    },
    operational_notes: {
      field: 'operational_notes',
      label: 'Operational Notes',
      validator: () => true,
      type: 'string',
      required: false
    },
    tags: {
      field: 'tags',
      label: 'tags',
      validator: () => true,
      type: 'array',
      required: false
    },
    meta: {
      field: 'meta',
      label: 'meta',
      validator: () => true,
      type: 'json',
      required: false
    },
    invoiced: {
      field: 'invoiced',
      label: 'invoiced',
      validator: () => true,
      type: 'boolean',
      required: false
    },
    batch_id: {
      field: 'batch_id',
      label: 'Batch ID',
      validator: () => true,
      readonly: true,
      type: 'array',
      required: false
    }
  }

// specify actions etc. for orders using Directr
const state = {}
const getters = {}
const mutations = {}
const actions = {}
const options = {
  // import: true
}

export default ContentModule<CtSourceOrder>(
  ContentType.SourceOrder, 'Services/Directr',
  model,
  state,
  getters,
  mutations,
  actions,
  options)
